import { DEFAULT_REGION, REGION_LABEL_MAP } from '../constants';

/**
 * Returns the human-readable label for a regionFilter in the Statement Selector, as follows:
 * | Value         | Label         |
 * |---------------|---------------|
 * | standard      | Domestic      |
 * | international | International |
 * @param {PRORegionFilter} regionFilter
 * @return {string}
 */
export const getRegionFilterLabel = (regionFilter: PRORegionFilter): string =>
    REGION_LABEL_MAP.get(regionFilter) ?? DEFAULT_REGION.label;
